import React from 'react';
import '../../../assets/constructionPageCss/style.css';
import platformSvg from '../../../assets/images/construction/platform.svg';

function UnderConstruction() {
  return (
  <div class="maintenance">
    <img src={platformSvg} class="logo" alt="Adcropper Platform" draggable="false" />
    <div class="stripe"></div>
    <div class="under"></div>
  </div>
  )
}

export default UnderConstruction
